export interface DeploymentConfig {
  conferenceServiceUrl: string;
}

export const DEPLOYMENT_CONFIG_PATH = "assets/config/deployment.json";

export const parseDeploymentConfig = (raw: unknown): DeploymentConfig => {
  if (!raw || typeof raw !== "object" || !("conferenceServiceUrl" in raw)) {
    throw new Error("deployment.json is missing conferenceServiceUrl");
  }

  const { conferenceServiceUrl } = raw;
  if (typeof conferenceServiceUrl !== "string" || conferenceServiceUrl.trim() === "") {
    throw new Error("deployment.json conferenceServiceUrl must be a non-empty string");
  }

  return { conferenceServiceUrl: new URL(conferenceServiceUrl.trim()).toString().replace(/\/+$/, "") };
};

export const loadDeploymentConfig = async (origin: string, fetchFn: typeof fetch = fetch): Promise<DeploymentConfig> => {
  const response = await fetchFn(new URL(DEPLOYMENT_CONFIG_PATH, origin).toString(), { cache: "no-cache" });
  if (!response.ok) {
    throw new Error(`Failed to load deployment config: HTTP ${response.status}`);
  }

  return parseDeploymentConfig(await response.json());
};

let current: DeploymentConfig | null = null;

export const initialiseDeployment = async (): Promise<DeploymentConfig> => {
  current = await loadDeploymentConfig(window.location.origin);
  return current;
};

export const serviceUrl = (path: string): string => {
  if (!current) {
    throw new Error("Deployment config not initialised");
  }

  return `${current.conferenceServiceUrl}${path}`;
};
